module.exports = __webpack_public_path__ + "static/media/section1-icon3.779f8641.png";